import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
//components
import Panel from "../../../components/panel/panel";
//primereact
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
//utils
import { formatCurrency } from "../../../utils/formatCurrency";
//services
import ModulePaymentModal from "./ModulePaymentModal";
import { useModuleContext } from "../ModuleContext";

const ModulesDetails = () => {
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);

  const { setVisible } = useModuleContext();

  const items = [
    {
      template: () => (
        <Link to={`/modules`} className="p-breadcrumb-link">
          Módulos adicionais
        </Link>
      ),
    },
    {
      template: () => (
        <Link to={`/salesManagement`} className="p-breadcrumb-link">
          {state.name ? state.name : "Módulo"}
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  return (
    <>
      <div className="col-md-4">
        <BreadCrumb model={items} home={home} className="breadCrumb" />
      </div>
      <div className="row">
        <div className="col-md-5">
          <Panel>
            <div className="d-flex justify-content-center">
              <img
                className="border rounded-circle image-details"
                src={
                  state.photo !== "uma_photo_aqui"
                    ? state.photo
                    : `https://i.pinimg.com/564x/f0/fd/35/f0fd35a4862eb163692443d112d29d5f.jpg`
                }
                alt="module"
              />
            </div>
            <div className="text-center mt-3">
              <h3>Integração com {state.name} </h3>
              <h6>Desenvolvido pela Ib System</h6>
            </div>
            <div className="d-flex justify-content-center">
              <div className="text-center w-75 rounded py-2">
                <h2>
                  <span className="text-success">
                    {formatCurrency(state.value)}
                  </span>
                  / Mês
                </h2>
                <h5>Incluso suporte técnico e atualizações</h5>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <div className="text-center w-75 py-2">
                <Button
                  label={state.has_signeds ? "Contratado" : "Assinar"}
                  disabled={state.has_signeds}
                  className="py-2 w-75 px-5 mt-3"
                  severity="text-success"
                  loading={loading}
                  onClick={() => setVisible(true)}
                  rounded
                />
              </div>
            </div>
          </Panel>
        </div>
        <div className="col-md-7">
          <Panel mainCss="p-2">
            <div>
              <iframe
                width="100%"
                height="350"
                src={state.link_video}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </Panel>
        </div>
        <div className="col-md-12">
          <Panel mainCss="mt-3 p-3">
            <div>
              <h3 className="text-success">
                Apresentação<i className="fa-solid fa-circle-play mx-2"></i>
              </h3>
              <h6>{state.desc}</h6>
              <h3 className="text-success mt-3 mb-2">
                O que este módulo faz por você{" "}
                <i className="fa-solid fa-circle-question mx-2"></i>
              </h3>
              <h6 className="mt-2">
                {state.horizontal_list_benefits
                  ?.split(", ")
                  .map((benefit, index) => (
                    <span
                      key={index}
                      className="p-1 mx-1 px-2 bg-gray-300 rounded-pill span-details"
                    >
                      {benefit}
                    </span>
                  ))}
              </h6>
              {state.vertical_list_benefits && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: state.vertical_list_benefits,
                  }}
                />
              )}
            </div>
          </Panel>
        </div>
      </div>

      <ModulePaymentModal />
    </>
  );
};

export default ModulesDetails;
